module.exports = __webpack_public_path__ + "static/media/flooring_material_10y_n.a221dc65.csv";